import { useState } from "react";
import { AnimatePresence, motion, usePresence, Variants } from "framer-motion";
import {
  CounterButton,
  CounterButtonWrapper,
  DogeBoxImg,
  DogeBoxImgWrapperDesktop,
  DogeBoxImgWrapperIpad,
  DogeBoxImgWrapperMobile,
  DogeBoxWrapper,
  DogeHeadImgWrapper,
  MintInfoWrapper,
  StyledCounter,
  TokenValue,
  DogeHeadImg,
} from "./styled";
import { Flex } from "Element/Flex";
import ethLogo from "assets/icons/eth-1.svg";
import { ReactComponent as AddIcon } from "assets/icons/add.svg";
import { ReactComponent as SubstractIcon } from "assets/icons/min.svg";
import dogeBoxDeskB from "assets/images/doge-box-desk-back.svg";
import dogeBoxDeskF from "assets/images/doge-box-desk-front.svg";
import dogeBoxMobB from "assets/images/doge-box-mob-back.svg";
import dogeBoxMobF from "assets/images/doge-box-mob-front.svg";
import dogeImg from "assets/logo/logo.svg";

import faker from "faker";

const dogePopCh: Variants = {
  hidden: { y: 32 },
  show: {
    y: 0,
  },
  exit: { y: 32 },
};

const DogeBox = () => {
  const name = () => `${faker.name.firstName()}`;
  const [dogeCount, setDogeCount] = useState<string[]>([]);
  const [isPresent, safeToRemove] = usePresence();

  const handleCounter = (amount: number) => {
    if (amount < 0) {
      if (dogeCount.length > 0) {
        dogeCount.shift();
        setDogeCount([...dogeCount]);
      }
    } else {
      if (dogeCount.length < 20) setDogeCount([name(), ...dogeCount]);
    }
  };

  const CounterComp = () => (
    <>
      <CounterButton className="btn-sub" onClick={() => handleCounter(-1)}>
        <SubstractIcon />
      </CounterButton>
      <StyledCounter>{dogeCount.length}</StyledCounter>
      <CounterButton className="btn-add" onClick={() => handleCounter(1)}>
        <AddIcon />
      </CounterButton>
    </>
  );

  const AmountEth = () => (
    <>
      <Flex flexDirection="row" alignItems="center">
        <img src={ethLogo} width={32} height={32} alt="" />
        <h2>
          {(0.8 * dogeCount.length).toFixed(dogeCount.length !== 0 ? 1 : 0)} ETH
        </h2>
      </Flex>
      <TokenValue>${dogeCount.length * 3250}</TokenValue>
    </>
  );

  const AmountDoge = () => (
    <DogeHeadImgWrapper>
      <AnimatePresence exitBeforeEnter>
        {[...dogeCount].map((name) => (
          <DogeHeadImg
            as={motion.img}
            variants={dogePopCh}
            src={dogeImg}
            key={name}
            initial="hidden"
            animate="show"
            onAnimationComplete={() => !isPresent && safeToRemove}
          />
        ))}
      </AnimatePresence>
    </DogeHeadImgWrapper>
  );

  return (
    <DogeBoxWrapper>
      <DogeBoxImgWrapperDesktop>
        <DogeBoxImg src={dogeBoxDeskB} />
        <DogeBoxImg src={dogeBoxDeskF} />
        <AmountDoge />
        <MintInfoWrapper>
          <Flex gap={24}>
            <AmountEth />
          </Flex>
          <Flex flexWrap="nowrap" alignItems="stretch" gap={12}>
            <CounterComp />
          </Flex>
        </MintInfoWrapper>
      </DogeBoxImgWrapperDesktop>
      <DogeBoxImgWrapperIpad>
        <DogeBoxImg src={dogeBoxDeskB} />
        <DogeBoxImg src={dogeBoxDeskF} />
        <AmountDoge />
        <MintInfoWrapper>
          <Flex className="mint-info" gap={24} gapM={10}>
            <AmountEth />
          </Flex>
        </MintInfoWrapper>
      </DogeBoxImgWrapperIpad>
      <DogeBoxImgWrapperMobile>
        <DogeBoxImg src={dogeBoxMobB} />
        <DogeBoxImg src={dogeBoxMobF} />
        <AmountDoge />
        <MintInfoWrapper>
          <Flex className="mint-info" gap={24} gapM={10}>
            <AmountEth />
          </Flex>
        </MintInfoWrapper>
      </DogeBoxImgWrapperMobile>
      <CounterButtonWrapper>
        <CounterComp />
      </CounterButtonWrapper>
    </DogeBoxWrapper>
  );
};

export default DogeBox;
